<template>
  <div>
    <validation-provider
      :name="$t(config.name)"
      :rules="fromAlarm ? '' : config.rules"
      v-slot="{ errors }"
    >
      <label class="d-block">
        {{ $t(`commands.form.${config.name}.label`) }}
      </label>
      <v-select
        v-model="model"
        :options="alarmTypesOptions"
        :clearable="true"
        :reduce="(val) => val.value"
        input-id="alarm_type"
        :multiple="multiple"
        :disabled="fromAlarm"
        @input="$emit('input', model)"
      />
      <p v-if="config.hint" class="mb-0 small">{{ $t(config.hint) }}</p>
      <p v-if="errors" class="small text-danger">{{ errors[0] }}</p>
    </validation-provider>
    <div class="form-group form-check mt-1" v-if="showFromAlarm">
      <validation-provider vid="alarm_types_from_alarm">
        <input
          type="checkbox"
          class="form-check-input"
          name="alarm_types_from_alarm"
          v-model="fromAlarm"
          value="from_alarm"
        />
      </validation-provider>
      <label class="form-check-label">
        {{ $t("commands.form.location.fields.from_alarm") }}
      </label>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { ValidationProvider } from "vee-validate";
import store from "@/store";

export default {
  components: {
    vSelect,
    ValidationProvider,
  },
  props: {
    value: Array | Object,
    multiple: Boolean | Number,
    config: Object,
    context: Object,
    nodeConfig: Object,
  },
  data() {
    return {
      model: null,
      options: [],
      fromAlarm: false,
      showFromAlarm: false,
    };
  },
  created() {
    this.showFromAlarm = this.context.flowchartConfig.alarm_compatible;
    this.model = this.value || null;
    this.fromAlarm = this.showFromAlarm && this.value === "from_alarm";
  },
  mounted() {
    store.dispatch("alarm/getAlarmTypes");
  },
  watch: {
    fromAlarm: {
      handler(value) {
        if (value) {
          this.$emit("input", "from_alarm");
          this.model = null;
        } else {
          this.$emit("input", null);
        }
      },
    },
  },
  computed: {
    alarmTypes() {
      return store.getters["alarm/getAlarmTypes"];
    },
    alarmTypesOptions() {
      if (this.options.length) {
        return this.options;
      }

      this.options = [...this.alarmTypes];

      return this.options;
    },
  },
};
</script>

<style></style>
